import React, { Component } from 'react';
import { Spin, Button, Modal, message, Tabs, Form, Checkbox } from 'antd';
import { connect } from 'dva';
import router from 'umi/router';
import moment from "moment";
import FormCreate from '../../../../../components/FormCreate/index';
import Container from '../../../../../components/Container';
import ArticleTable from './components/ArticleTable';
import SelectList from './components/SelectList';
import { getAppCode } from '../../utils/utils';
import { kindergartenClass, primarySchoolClass, middleSchoolClass, allIdList } from '../utils/classData';
import styles from './index.less';

const { confirm } = Modal;
const { TabPane } = Tabs;

const {
  DateAndTime,
  FormRadioGroup,
  FormCheckbox,
  SelectUserVersion4,
} = FormCreate;

@Form.create()

@connect(({ push, user }) => ({
  ...push,
  currentUser: user.currentUser,
}))

class BatchPush extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeKey: '1',
      pushTime: moment().add(2, "hours"),
      checkAll: false,
    };
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'push/reset',
    });
  }

  renderTabTitle = (activeKey, title, index) => {
    return (
      <span>
        <i
          className={
            activeKey === index ? 'common-icon-style active-style' : 'common-icon-style icon-style'
          }
        >
          {index}
        </i>
        {title}
      </span>
    );
  };

  changeTab = activeKey => {
    this.setState({ activeKey });
  };


  confirmPush = () => {
    const { selectedRow, form, student } = this.props;
    const selectedNum = selectedRow.length;
    const { validateFields, getFieldsValue } = form;
    const values = getFieldsValue();
    const { isEmployee, isStudent, isTiming, pushTime } = values;
    const that = this;
    if (selectedNum === 0) {
      message.error('请选择文章');
    } else {
      if (Number(isTiming) === 1) {
        if (new Date() > new Date(pushTime)) {
          message.error('定时发送选择时间小于现在时间');
          return;
        }
      }
      validateFields(err => {
        if (!err) {
          if (!isEmployee && !isStudent) {
            message.error('请选择发布对象');
            return;
          }
          if (isStudent && student.length === 0) {
            message.error('请选择学生学段');
            return;
          }
          confirm({
            title: '确定发送文章提醒吗',
            content: '',
            okText: '确定',
            cancelText: '取消',
            className: styles.confirmModal,
            onOk() {
              that.fetchPushNews();
            },
            onCancel() {
              console.log('Cancel');
            },
          });
        } else {
          message.error('信息填写页必填项未填写完整');
        }
      });
    }
  };

  fetchNewsPreview = () => {
    const { dispatch, selectedRow = [] } = this.props;
    const ids = [];
    selectedRow.forEach(item => {
      ids.push(item.id);
    });
    dispatch({
      type: 'push/fetchNewsPreview',
      params: {
        id: ids.join(','),
        appCode: getAppCode(),
      },
    })
      .then(() => {
        message.success('预览发布成功');
      })
      .catch(() => {
        dispatch({
          type: 'push/saveState',
          payload: { spinning: false },
        });
      });
  };

  fetchPushNews = () => {
    const { dispatch, selectedRow = [], form, student, } = this.props;
    const { getFieldsValue } = form;
    const values = getFieldsValue();
    const { isTiming, pushTime, selectId, isStudent, isEmployee } = values;
    const ids = [];
    selectedRow.forEach(item => {
      ids.push(item.id);
    });

    const params = {
      ids,
      appCode: getAppCode(),
      selectId,
      selectIdType: 3,
      isTiming,
      pushTime: new Date(pushTime),
      selectSetting: {
        isStudent: isStudent ? 1 : 0,
        isEmployee: isEmployee ? 1 : 0,
        student: student.toString(),
      },
    }

    dispatch({
      type: 'push/fetchPushCourse',
      params,
    }).then(() => {
      message.success('推送成功');
      router.goBack();
    });
  };

  nextStep = () => {
    const { activeKey } = this.state;
    this.setState({
      activeKey: `${Number(activeKey) + 1}`
    })
  };

  preStep = () => {
    const { activeKey } = this.state;
    this.setState({
      activeKey: `${Number(activeKey) - 1}`
    })
  };

  renderFooter = () => {
    const { selectedRow } = this.props;
    const selectedNum = selectedRow.length;
    const { activeKey } = this.state;
    const footerParams = {
      states: !0,
      demFooter: (
        <>
          <Button disabled={selectedNum === 0} onClick={this.fetchNewsPreview}>
            预 览
          </Button>
          {["2", "3"].indexOf(activeKey) > -1 && (
            <Button type="default" onClick={this.preStep}>
              上一步
            </Button>
          )}
          {["1", "2"].indexOf(activeKey) > -1 && (
            <Button type="primary" onClick={this.nextStep}>
              下一步
            </Button>
          )}

          {
            activeKey === '3' && (
              <Button type="primary" onClick={() => this.confirmPush()}>
                推送
              </Button>
            )
          }
        </>
      ),
    };
    return footerParams;
  };


  chooseStudent = checkedValues => {
    const { dispatch } = this.props;
    dispatch({
      type: 'push/saveState',
      payload: { student: checkedValues },
    });
    this.setState({
      checkAll: checkedValues.length === allIdList.length,
    });
  }

  onCheckAllChange = e => {
    const { dispatch } = this.props;
    dispatch({
      type: 'push/saveState',
      payload: {
        student: e.target.checked ? allIdList : []
      },
    });

    this.setState({
      checkAll: e.target.checked,
    });
  };

  render() {
    const { spinning, form, dispatch, formData, student, currentUser } = this.props;
    const { getFieldValue } = form;
    const { activeKey, pushTime, checkAll } = this.state;
    const { orgType } = currentUser || {};
    const { selectId, isStudent } = formData;
    const customerFormItemLayout = {
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
    };


    const remindTimeProps = {
      form,
      value: 0,
      label: '推送时间',
      keyName: 'isTiming',
      isRequired: true,
      RadioGroupOptions: [
        { label: '立即推送', value: 0 },
        { label: '定时推送', value: 1 },
      ],
    };

    const timeProps = {
      form,
      value: moment(pushTime, "YYYY.MM.DD HH:mm"),
      label: '定时推送时间',
      keyName: 'pushTime',
      message: '定时推送时间',
      showTime: { defaultValue: moment("00:00", "HH:mm") },
      datePickerFormat: "YYYY-MM-DD HH:mm",
      tips: '说明: 推送可能因为网络原因延迟，请确认推送记录是否存在记录，请勿重复推送，定时发送的内容保存至操作记录-推送记录处',
    };

    const disabledDate = current => {
      // Can not select days before today and today
      return current && current < moment().startOf("day");
    };

    const formItemLayout = {
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
    };

    const isStudentProps = {
      form,
      value: isStudent,
      label: "学生",
      keyName: "isStudent",
      isRequired: false,
      onChange: e => {
        dispatch({
          type: 'push/saveState',
          payload: {
            formData: {
              ...formData,
              isStudent: Number(e.target.checked)
            },
          },
        });
      },
    };

    const isEmployeeProps = {
      form,
      value: 0,
      label: "教职工",
      keyName: "isEmployee",
      isRequired: false,
    };

    const selectUserProps = {
      form,
      value: selectId,
      appName: '宣传管理',
      appId: 1,
      label: '组织选择',
      message: '选择需要发送的组织',
      keyName: 'selectId',
      isRequired: true,
      orgType,
      selectProps: {
        multiple: true,
        selectType: "dept",
        strictOrgRel: false,
        showTabList: ['orgRel'],
        dialogProps: {
          title: "选择对象",
        },
        searchPlaceholder: '搜索名称',
        selectSignature: selectId,
        isSaveSelectSignature: true,
        requestParams: {
          strictUser: true,
          selectTypeList: ['org_rel'],
        },
      }
    };

    return (
      <Container breStates={!0} version={2} defaultPadding footerParams={this.renderFooter()}>
        <div className={styles.root}>
          <FormCreate customerFormItemLayout={customerFormItemLayout}>
            <Tabs defaultActiveKey="1" activeKey={activeKey} onChange={this.changeTab}>
              <TabPane tab={this.renderTabTitle(activeKey, '课程选择', '1')} key="1">
                <Spin spinning={spinning}>
                  <div className="content">
                    <section className="left">
                      <SelectList type="batchPush" />
                    </section>
                    <section className="right">
                      <ArticleTable type="batchPush" />
                    </section>
                  </div>
                </Spin>
              </TabPane>
              <TabPane tab={this.renderTabTitle(activeKey, '补推对象', '2')} key="2">
                <SelectUserVersion4 {...selectUserProps} />
                <Form.Item label="对象" {...formItemLayout} className="send-user">
                  <div className='people-type-select'>
                    <FormCheckbox {...isStudentProps} />
                  </div>

                  <div className='class-group'>
                    <div className='title'>学段</div>
                    <div className='checkbox-wrap'>
                      <Checkbox
                        onChange={this.onCheckAllChange}
                        checked={checkAll}
                        disabled={isStudent !== 1}
                      >
                        全选
                      </Checkbox>
                      <Checkbox.Group onChange={this.chooseStudent} value={student}>
                        <div>
                          {
                            kindergartenClass.map(item => {
                              return <Checkbox value={item.key} disabled={isStudent !== 1}>{item.name}</Checkbox>
                            })
                          }
                        </div>
                        <div>
                          {
                            primarySchoolClass.map(item => {
                              return <Checkbox value={item.key} disabled={isStudent !== 1}>{item.name}</Checkbox>
                            })
                          }
                        </div>
                        <div>
                          {
                            middleSchoolClass.map(item => {
                              return <Checkbox value={item.key} disabled={isStudent !== 1}>{item.name}</Checkbox>
                            })
                          }
                        </div>
                      </Checkbox.Group>
                    </div>
                  </div>
                  <div className='people-type-select'>
                    <FormCheckbox {...isEmployeeProps} />
                  </div>
                </Form.Item>
              </TabPane>
              <TabPane tab={this.renderTabTitle(activeKey, '发送属性', '3')} key="3">
                <FormRadioGroup {...remindTimeProps} />
                {
                  Number(getFieldValue("isTiming")) === 1 && <DateAndTime disabledDate={disabledDate} {...timeProps} />
                }
              </TabPane>
            </Tabs>
          </FormCreate>
        </div>
      </Container>
    );
  }
}

export default BatchPush;
